import React from 'react';
import styled from 'styled-components';
import { Typography } from '@mui/material';
import { PALETTE, FONT_SIZES } from '~/assets/styles/base';

const Wrapper = styled.div`
  width: 100%;
  padding: 45px;
  background: ${PALETTE.white};
  text-align: center;
  white-space: pre-line;
`;

const Title = styled(Typography)`
  color: ${PALETTE.text.primary};
  padding-top: 10px;
  font-size: ${FONT_SIZES.title3};
`;

const Message = styled(Typography)`
  color: ${PALETTE.text.primary};
  padding-top: 10px;
  font-size: ${FONT_SIZES.body1};
`;

const Desc = styled(Typography)`
  font-size: ${FONT_SIZES.title2};
  padding-top: 10px;
`;

const ButtonWrapper = styled.div`
  & .MuiButton-root {
    margin: 0 auto;
    margin-top: 30px;
    color: ${PALETTE.primary.main};
    border: 1px solid ${PALETTE.primary.main};
  }
`;

type Props = {
  title?: string;
  message?: string;
  desc?: string;
  button?: JSX.Element;
  children?: JSX.Element;
};
const MessageArea: React.FC<Props> = ({ title, message, desc, button, children }): JSX.Element => (
  <Wrapper>
    <div>
      {children}
      {title ? <Title data-testid="uiParts-MessageAreaTitle">{title}</Title> : null}
      {message ? <Message data-testid="uiParts-MessageAreaMessage">{message}</Message> : null}
      {desc ? <Desc data-testid="uiParts-MessageAreaDesc">{desc}</Desc> : null}
      {button ? <ButtonWrapper>{button}</ButtonWrapper> : null}
    </div>
  </Wrapper>
);

export default MessageArea;
